import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import SubcriptionReportsChild from "./SubcriptionReportsChild";

const SubscriptionReports = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <SubcriptionReportsChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default SubscriptionReports;
